<template>
  <b-col class="col-lg-10" offset="1">
    <b-container fluid>
      <b-row>
        <b-col class="col-lg-12" style="margin-top: 15px">
          <h2 class="text-left">{{title}}</h2>
          <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
          <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-lg-12 border" style="padding-top: 10px">
          <b-form-group label=""
                        label-for="filter-input"
                        label-cols="0">
            <b-input-group>
              <b-form-input id="filter-input"
                            v-model="filter"
                            type="search"
                            placeholder="Type om te zoeken"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''" size="sm">Wissen</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-table striped hover outlined
                   id="articlesTable"
                   :items="articles"
                   :fields="fields"
                   :filter="filter"
                   :filter-included-fields="filterOn"
                   :per-page="perPage"
                   :current-page="currentPage"
                   @filtered="onFiltered"
                   sort-icon-left>
            <template #cell(options)="row">
              <b-link v-bind:to="{ name: 'articledetails', params: { id: row.item.id } }">Wijzig</b-link>
            </template>
          </b-table>
          <b-pagination v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="articlesTable"></b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </b-col>
</template>

<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'

  export default {
    name: 'ArticlesOverview',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        title: 'Overzicht artikelen',
        loading: false,
        articles: [],
        fields: [
          {
            key: 'productId',
            label: 'Item',
            sortable: true,
          },
          {
            key: 'itemdescription',
            label: 'Omschrijving',
            sortable: true,
          },
          {
            key: 'brand',
            label: 'Merk',
            sortable: true,
          },
          {
            key: 'season',
            label: 'Seizoen',
            sortable: true,
          },
          {
            key: 'unit',
            label: 'Eenheid',
            sortable: true,
          },
          {
            key: 'salesprice',
            label: 'Verkoopprijs',
          },
          {
            key: 'rrp',
            label: 'Adviesprijs',
          },
          {
            key: 'options',
            label: 'Opties'
          }
        ],
        totalRows: 1,
        perPage: 10,
        currentPage: 1,
        filter: null,
        filterOn: ['productId', 'brand', 'itemdescription', 'season']
      }
    },
    created: function () {
      this.loading = true;
      this.$api.get('article/list')
        .then((response) => {
          this.articles = response.data
          this.totalRows = this.articles.length
        })
        .catch((error) => {
          this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de artikelen.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    computed: {      
    },
    methods: {      
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      }
    }
  }
</script>
